import React, {useState, useEffect, useRef} from 'react';
import FaClose from 'react-icons/lib/fa/close';
import './EmailCaptureModal.scss';
import amiraWaving from '../../../assets/reports/amira_waving.png';
import { isValidEmail } from '../../services/util';
import { getUserData } from '../../services/API';
import SIS from '../../services/StudentInformationService';
import { createHubSpotContact } from '../../services/segmentService';

export default function EmailCaptureModal() {

  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [teacher, setTeacher] = useState(null);
  const [isValidationError, setIsValidationError] = useState(false);
  const textInputRef = useRef(null);

  useEffect(() => {
    getMetadata();
  }, [])

  const getMetadata = async () => {
    try {
      const teacher = await SIS.getStudent(getUserData().userId);
      if (!teacher?.metadata?.hasSeenCaptureEmailModal) {
        setIsOpen(true);
        setTeacher(teacher);
        textInputRef?.current?.focus();
      }
    } catch (e) {
      console.error('unable to retrieve teacher metadata', e);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const teacherEmail = email.trim().toLowerCase();
    if (!isValidEmail(teacherEmail)) {
      textInputRef?.current?.focus();
      return setIsValidationError(true);
    }
    try {
      const userData = getUserData();
      const payload = {
        email: teacherEmail,
        firstname: teacher?.first_name,
        lastname: teacher?.last_name,
        district_id: userData?.districtId?.toString(),
        school_ids: userData?.schools?.map(school => school.id).join(', ')
      }
      createHubSpotContact(payload);
      SIS.setSeenCaptureEmailModal(getUserData().userId, true);
    } catch (e) {
      console.error('Email capture submit error', e);
    } finally {
      handleClose();
    }
  }

  const handleSkip = () => {
    SIS.setSeenCaptureEmailModal(getUserData().userId, true);
    handleClose();
  }

  const handleSetEmail = (e) => {
    setEmail(e.target.value);
    setIsValidationError(false);
  }

  const handleClose = () => {
    setIsOpen(false);
  }

  if (!isOpen) return null;

  return (
    <div className='email-capture-modal-container'>
      <div className='email-capture-modal-backdrop' />
      <div className='email-capture-modal'>
        <div className='email-capture-modal-content'>
          <img src={amiraWaving} className='email-capture-modal-amira-image' />
          <div>
            <div className='email-capture-modal-title'>Get Started</div>
            <div className='email-capture-modal-subtitle'>Enter your email below to get started:</div>
            <form className='email-capture-modal-form' onSubmit={handleSubmit}>
              <input
                ref={textInputRef}
                className='email-capture-modal-input'
                placeholder='johndoe@mail.com'
                value={email}
                onChange={handleSetEmail}
              />
              <button type='submit' className='email-capture-modal-button'>Submit</button>
              {isValidationError && <div className='email-capture-modal-error-text'>Please enter a valid email.</div>}
            </form>
            <div className='email-capture-modal-skip-text'>
              Or just <button className='email-capture-modal-skip-button' onClick={handleSkip}>skip this step.</button>
            </div>
          </div>
          <button className='email-capture-modal-close-button' onClick={handleClose}>
            <FaClose size={28} />
          </button>
        </div>
      </div>
    </div>
  )
}
